// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ktywphxmqafinzfgzhps.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt0eXdwaHhtcWFmaW56Zmd6aHBzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY4ODAzNzYsImV4cCI6MjA1MjQ1NjM3Nn0.bn8PWThGK4EYgSegAiCMkL4VeVgmdnCuK_tjzdvMMac";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);